import { RecurringSchedule } from '../recurringPayments/recurringSchedule';
import { StreetAddress } from '../streetAddress/streetAddress';
import { TransactionType, TransactionTypeVerb } from '../../core/constants';
import { L2L3Data } from './L2L3Data';
import { L2L3Item } from './L2L3Item';

export class OrderDetails {
  orderId: string;
  merchantId: string;
  createDate: Date;
  //magnifiedTotalAmount: number;
  //currencyCode: string;
  //magnifier: number;
  //tokenizedCardId: string;
  //transactionTypeId:number;

  merchantName: string | undefined;
  customerId: string | undefined;
  customerFirst: string | undefined;
  customerLast: string | undefined;
  billingAddress: Partial<StreetAddress> | undefined;
  shippingAddress: Partial<StreetAddress> | undefined;
  isRecurring: boolean = false;
  recurringSchedule: RecurringSchedule | undefined;
  totalAmount: number | undefined;
  orderType: string | undefined;
  cardBrand: string | undefined;
  cardFirst6: string | undefined;
  cardLast4: string | undefined;
  cardExpMM: string | undefined;
  cardExpYY: string | undefined;
  transactions: number | undefined;
  description: string | undefined;
  recipientEmail: string | undefined;
  invoiceNumber: string | undefined;
  poNumber: string | undefined;
  productCode: string | undefined;
  transactionType: TransactionType;
  L2L3Data: Partial<L2L3Data> | undefined;
  L2L3Items: L2L3Item[] = []; 



  constructor(order: Partial<OrderDetails>) {
    if (order.orderId == null) {
      throw 'Order requires orderId';
    } else if (order.merchantId == null) {
      throw 'Order requires merchantId';
    } else if (order.createDate == null) {
      throw 'Order requires createDate';
      //} else if (order.magnifiedTotalAmount == null) {
      //    throw "Order requires magnifiedTotalAmount";
      //} else if (order.currencyCode == null) {
      //    throw "Order requires currencyCode";
      //} else if (order.magnifier == null) {
      //    throw "Order requires magnifier";
      //} else if (order.tokenizedCardId == null) {
      //    throw "Order requires tokenizedCardId";
      //} else if (order.transactionTypeId == null) {
      //    throw "Order requires transactionTypeId";
    }
   

    this.orderId = order.orderId;
    this.merchantId = order.merchantId;
    this.merchantName = order.merchantName;
    this.createDate = order.createDate;
    //this.magnifiedTotalAmount = order.magnifiedTotalAmount;
    this.totalAmount = order.totalAmount;
    //this.currencyCode = order.currencyCode;
    //this.magnifier = order.magnifier;
    //this.customerId = order.customerId;
    //this.tokenizedCardId = order.tokenizedCardId;
    //this.transactionTypeId = order.transactionTypeId;
    this.recurringSchedule = order.recurringSchedule;
    this.isRecurring = order.isRecurring || false;
    this.shippingAddress = order.shippingAddress;
    this.billingAddress = order.billingAddress;
    this.orderType = order.orderType;
    this.customerFirst = order.customerFirst;
    this.customerLast = order.customerLast;
    this.cardBrand = order.cardBrand;
    this.cardFirst6 = order.cardFirst6;
    this.cardLast4 = order.cardLast4;
    this.cardExpMM = order.cardExpMM;
    this.cardExpYY = order.cardExpYY;
    this.transactions = order.transactions;
    this.description = order.description;
    this.recipientEmail = order.recipientEmail;
    this.invoiceNumber = order.invoiceNumber;
    this.poNumber = order.poNumber;
    this.productCode = order.productCode;
    this.L2L3Data = order.L2L3Data;
    if (order.transactionType) {
      this.transactionType = order.transactionType;
    } else {
      this.transactionType = TransactionType.TRANSACTION_TYPE_AUTHCAPTURE;
    }
    this.L2L3Items = order.L2L3Items || [];
  }

  static createEmpty() {
    //return new Order({orderId:"", merchantId:"", createDate:new Date(), magnifiedTotalAmount:0, currencyCode:"", magnifier:0, tokenizedCardId:"", transactionTypeId:0});
    return new OrderDetails({
      orderId: '',
      merchantId: '',
      createDate: new Date(),
      description: '',
      recipientEmail: '',
    });
  }
}
